// extracted by mini-css-extract-plugin
export default {"switcherButton":"yNJs2d","active":"EDZavD","tooltip":"VRAia2"};